import { render, staticRenderFns } from "./AdminAddZone.vue?vue&type=template&id=1684df33&scoped=true&"
import script from "./AdminAddZone.vue?vue&type=script&lang=ts&"
export * from "./AdminAddZone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1684df33",
  null
  
)

export default component.exports